module.exports = __webpack_public_path__ + "static/media/ksn-horizon.769c8a14.png";